import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53e6030e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-card__content" }
const _hoisted_2 = { class: "user-card__name" }
const _hoisted_3 = { class: "user-card__reports" }
const _hoisted_4 = { class: "divider" }

import { PropType } from 'vue'
import { UserType } from '@/shared/types'


export default /*#__PURE__*/_defineComponent({
  props: {
  user: Object as PropType<UserType>,
  active: Boolean as PropType<boolean>,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["user-card", {
      'user-card--active': __props.active,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(__props.user.name), 1),
      _createElementVNode("p", _hoisted_3, "Отчётов: " + _toDisplayString(__props.user.reports_count), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_divider)
    ])
  ], 2))
}
}

})